module.exports = __webpack_public_path__ + "static/media/wawanesa.7b3f4b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/wawanesa.png
// module id = 131
// module chunks = 0